import React, { useEffect, useState } from "react";
import Container from "./Layout/Container";

const NON_ACTIVE_PAGES = [
  "/patient-care",
  "/diabetes-centre-locations",
  "/backend",
  "/category",
  "/backend/category",
];

const INVALID_PAGES = ["/backend", "/category", "/backend/category"];

const disableInactiveLink = (item = null) => {
  // checking if the link is valid page or not
  if (item?.link && NON_ACTIVE_PAGES.includes(item?.link))
    return { ...item, link: null };

  return item;
};

const removeInvalidLink = (item = null) => {
  if (item?.link && INVALID_PAGES.includes(item.link)) return null;
  return item;
};

const homeBreadcrumb = { label: "Home", link: "/" };

const useBreadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const pathSegments = window.location.pathname
      .split("/")
      .filter((segment) => segment);

    const generated = pathSegments
      .map((segment, index) => {
        const isLastSegment = index === pathSegments.length - 1;
        return {
          label:
            segment.charAt(0).toUpperCase() +
            segment.slice(1).toLowerCase().replaceAll("-", " "),
          link: isLastSegment
            ? null
            : "/" + pathSegments.slice(0, index + 1).join("/"),
        };
      })
      .filter(removeInvalidLink)
      .map(disableInactiveLink);

    setBreadcrumbs([homeBreadcrumb, ...generated]);
  }, []);

  return breadcrumbs;
};

const Breadcrumb = ({ breadcrumbs = [], hide = false }) => {
  const generatedBreadcrumbs = useBreadcrumbs();

  const breadcrumbItems =
    breadcrumbs && breadcrumbs.length > 0
      ? [homeBreadcrumb, ...breadcrumbs]
      : generatedBreadcrumbs;

  if (hide || !breadcrumbItems || breadcrumbItems.length === 0) {
    return null;
  }

  return (
    <Container className="py-4">
      <nav aria-label="breadcrumb">
        <ol className="flex list-none flex-wrap p-0">
          {breadcrumbItems.map((breadcrumb, index) => (
            <li key={index} className="flex items-center">
              {breadcrumb.link ? (
                <a
                  href={breadcrumb.link}
                  className="text-primary hover:underline"
                >
                  {breadcrumb.label}
                </a>
              ) : (
                <span className="text-gray-700">{breadcrumb.label}</span>
              )}
              {index < breadcrumbItems.length - 1 && (
                <span className="mx-2 text-gray-500">/</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </Container>
  );
};

export default Breadcrumb;
